import { useGame } from '../state/GameContext';
import { sounds, haptics } from '../utils/sounds';

export default function Header() {
  const { dispatch } = useGame();

  return (
    <div className="header">
      <h1 className="title">Photo Blender</h1>
      <p className="subtitle">Mix, Match & Guess the Photos!</p>

      <div className="flex gap-2 justify-center mt-3 flex-wrap">
        <button
          onClick={() => {
            dispatch({ type: 'SET_FIELD', field: 'showTutorial', value: true });
            sounds.click();
            haptics.light();
          }}
          className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white text-sm cursor-pointer transition-all duration-200 hover:bg-white/20"
        >
          How to Play
        </button>
        <button
          onClick={() => {
            dispatch({ type: 'SET_FIELD', field: 'showPrivacyPopup', value: true });
            sounds.click();
            haptics.light();
          }}
          className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white text-sm cursor-pointer transition-all duration-200 hover:bg-white/20"
        >
          Privacy
        </button>
        <button
          onClick={() => {
            sounds.setMuted(!sounds.getMuted());
            sounds.click();
            haptics.light();
            dispatch({ type: 'SHOW_SUCCESS', message: sounds.getMuted() ? 'Sounds muted' : 'Sounds enabled' });
            setTimeout(() => dispatch({ type: 'CLEAR_MESSAGES' }), 2000);
          }}
          className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white text-sm cursor-pointer transition-all duration-200 hover:bg-white/20"
          title={sounds.getMuted() ? 'Enable sounds' : 'Mute sounds'}
        >
          {sounds.getMuted() ? 'Unmute' : 'Mute'}
        </button>
      </div>
    </div>
  );
}
